import {
   HttpErrorResponse,
   HttpEvent,
   HttpEventType,
   HttpHandler,
   HttpHeaders,
   HttpInterceptor,
   HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { applicationVersionChanged } from '../app.actions';
import { UserSessionStorageService } from '../session/user-session-storage.service';

const ndtVersionHeaderName = 'Ndt-Version';

/**
 * Checks the 'NDT-Version' header in the response of all API calls.
 * If it differs from the current versions, dispatches an action that
 * prompts the user to reload the page.
 */
@Injectable()
export class AppVersionInterceptor implements HttpInterceptor {
   constructor(private store: Store, private userSessionStorage: UserSessionStorageService) {}

   intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      let shouldCheckVersionHeader: boolean;
      if (req.url.startsWith('/api')) {
         shouldCheckVersionHeader = true;
      } else if (req.url.startsWith('assets')) {
         shouldCheckVersionHeader = false;
      } else {
         const url = new URL(req.url);
         shouldCheckVersionHeader = url.host === location.host && url.pathname.startsWith('/api');
      }

      if (!shouldCheckVersionHeader) {
         return next.handle(req);
      }

      return next.handle(req).pipe(
         tap(
            (event) => {
               if (event.type === HttpEventType.Response) {
                  this.checkVersion(event.headers);
               }
            },
            (error) => {
               if (error instanceof HttpErrorResponse) {
                  this.checkVersion(error.headers);
               }
            }
         )
      );
   }

   private checkVersion(headers: HttpHeaders) {
      if (headers.has(ndtVersionHeaderName)) {
         const version = headers.get(ndtVersionHeaderName);
         if (version != null) {
            const oldVersion = this.userSessionStorage.getApplicationVersion();
            if (oldVersion && oldVersion !== version) {
               this.userSessionStorage.clearLocalStorage();
               this.userSessionStorage.setApplicationVersion(version);
               this.store.dispatch(applicationVersionChanged({ newVersion: version, oldVersion }));
            }
         }
      }
   }
}
